module.exports = __webpack_public_path__ + "assets/images/amira_initial_greeting2.fe7c43a1ad38814c122aa25cd8e23532.svg";